// src/data/sidebar_config.js

/**
 * Single source of truth for sidebar UI per role/app.
 * - role_key: normalized role name from user profile (lowercase, underscores)
 * - app_key: which portal/module is active (fund_manager, donor_portal, governance, entrepreneur)
 */

export const SIDEBAR_CONFIG = {
  fund_manager: {
    header_title: "Fund Manager",

    // ✅ Fund Manager menu (matches your latest design)
    menu: [
      {
        key: "enterprise_supplier_development",
        label: "Enterprise & Supplier Development",
        icon: "bi bi-shield-check",
        type: "section",
        children: [
          { key: "esd_programmes_delivery", label: "Programmes & Delivery", icon: "bi bi-clipboard-check" },
          { key: "esd_social_impact", label: "Social Impact", icon: "bi bi-globe", disabled: true },
          { key: "esd_compliance", label: "Compliance", icon: "bi bi-file-earmark-check", disabled: true }
        ]
      }
    ],

    include_programmes_component: false
  },

  donor_portal: {
    header_title: "Donor",
    menu: [
      {
        key: "enterprise_supplier_development",
        label: "Enterprise & Supplier Development",
        icon: "bi bi-shield-check",
        type: "section",
        children: [
          { key: "esd_compliance", label: "Compliance", icon: "bi bi-file-earmark-check", disabled: true },
          { key: "esd_programmes_delivery", label: "Programmes & Delivery", icon: "bi bi-clipboard-check" },
          { key: "esd_social_impact", label: "Social Impact", icon: "bi bi-globe", disabled: true }
        ]
      }
    ],
    include_programmes_component: false
  },

  governance: {
    header_title: "Governance",
    menu: [
      {
        key: "enterprise_supplier_development",
        label: "Enterprise & Supplier Development",
        icon: "bi bi-shield-check",
        type: "section",
        children: [
          { key: "esd_compliance", label: "Compliance", icon: "bi bi-file-earmark-check", disabled: true },
          { key: "esd_programmes_delivery", label: "Programmes & Delivery", icon: "bi bi-clipboard-check" },
          { key: "esd_social_impact", label: "Social Impact", icon: "bi bi-globe", disabled: true }
        ]
      }
    ],
    include_programmes_component: false
  },

  entrepreneur: {
    header_title: "Entrepreneur",
    menu: [
      {
        key: "enterprise_supplier_development",
        label: "Enterprise & Supplier Development",
        icon: "bi bi-shield-check",
        type: "section",
        children: [
          { key: "esd_compliance", label: "Compliance", icon: "bi bi-file-earmark-check", disabled: true },
          { key: "esd_programmes_delivery", label: "Programmes & Delivery", icon: "bi bi-clipboard-check" },
          { key: "esd_social_impact", label: "Social Impact", icon: "bi bi-globe", disabled: true }
        ]
      }
    ],
    include_programmes_component: false
  }
};

/**
 * Map normalized role names to sidebar config keys.
 * Example: "Fund Manager" -> "fund_manager"
 */
export const ROLE_TO_APP_KEY = {
  admin: "fund_manager",
  system_admin: "fund_manager",
  root_user: "fund_manager",
  fund_manager: "fund_manager",
  donor: "donor_portal",
  governance: "governance",
  entrepreneur: "entrepreneur"
};
